import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '..';
import Mosvita from '../../ui/typography/mosvita';
import { ContainerDetailIcon } from './style';
import colors from '../../ui/theme/partials/colors';
import { HtmlRaw } from '../../components';

const DetailIcon = ({ text, icon }) => (
  <ContainerDetailIcon>
    <Icon color={colors.secondary} size={30} type={`${icon}`} />
    <Mosvita type="detailIcon">
      <HtmlRaw html={text} />
    </Mosvita>
  </ContainerDetailIcon>
);

DetailIcon.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
};

export default DetailIcon;
